import { ProtocolMode } from '@azure/msal-common';

import { WoEnv } from './types';

export const environment: WoEnv = {
  production: false,
  envName: 'DEV',
  backendHost: 'https://api-dev.wo.apps.issworld-test.com/ordering',
  oauth2: {
    clientId: 'waste.app.dev',
    scope: 'waste.api.dev',
    authority: 'https://azsso-test.issworld.global/adfs/',
    knownAuthorities: [ 'https://azsso-test.issworld.global/adfs' ],
    protocol: ProtocolMode.OIDC,
  },
  keycloak: {
    url: 'https://dc-dev.sdc.apps.issworld-test.com',
    realm: 'wastemanager',
    clientId: 'wastemanager',
  },
  appName: 'ISS Smart Waste Control',
  mobileScheme: 'swc-iss-dev',
  support: {
    email: 'wast@dk.issworld.com',
    phone: '+45 44 44 60 70',
  },
  appInsights: {
    tenantId: '0e76efa8-a57a-46d8-a3f4-49f722a82f45',
    subscriptionId: 'edbef4c2-327b-4f27-9f43-bfa6a7acf518',
    resourceGroup: 'rg-gi-wo-dev',
    instanceName: 'wo-dev-app-insights',
  },
};
